
const suppressConsole = () => {
    console.info = () => undefined;
    console.warn = () => undefined;
    console.error = () => undefined;
    console.log = () => undefined;
};


export default {
  suppressConsole,
};
